import { render, staticRenderFns } from "./AccidentShow.vue?vue&type=template&id=000db279&"
import script from "./AccidentShow.vue?vue&type=script&lang=js&"
export * from "./AccidentShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports